<template>
  <div class="menu-wrapper">
    <!-- 仅有一个可显示的子路由,并且没有孙子路由 && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && item.alwaysShow-->
    <template v-if="!item.children">
      <router-link :to="item.path">
        <el-menu-item :index="item.path">
          {{item.title}}
        </el-menu-item>
      </router-link>
    </template>
    <el-submenu v-else ref="subMenu" :index="item.path" popper-append-to-body>
      <template v-slot:title>
        {{item.title}}
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item='child'/>
    </el-submenu>
  </div>
</template>

<script>

  export default {
    name: "SidebarItem",
    props: ['item'],
    data () {
      return {}
    },
    methods: {

    }

  }
</script>

<style scoped>
  .menu-wrapper >>> .el-menu-item, .menu-wrapper >>> .el-submenu__title {
    height: 40px;
    line-height: 40px;
  }
  .menu-wrapper>>>.el-menu-item.is-active{
    position: relative;
  }
  .menu-wrapper>>>.el-menu-item.is-active::after{
    content: '';
    position: absolute;
    bottom: 0;
    left:0;
    height: 4px;
    width: 100%;
    background-color: #E2B132;
  }
  .menu-wrapper>>>a,.menu-wrapper>>>a:active{
    text-decoration: none;
  }
</style>
